import { memo } from 'react';
import { cn } from '@divlab/divanui';

import CurrentDiscountsCard from '../CurrentDiscountCard';
import styles from './CategoryGroup.module.css';

import type { FC, HTMLAttributes } from 'react';
import type { OfferCategoryData } from '@Pages/PagePromotionsDiscounts/typings';

interface CategoryGroupProps extends HTMLAttributes<HTMLDivElement> {
  group: OfferCategoryData[];
}

const CategoryGroup: FC<CategoryGroupProps> = (props) => {
  const { className, group, ...restProps } = props;

  return (
    <div className={cn(styles.wrapper, className)} {...restProps}>
      {group.map((category) => (
        <CurrentDiscountsCard key={category.title} category={category} />
      ))}
    </div>
  );
};

export default memo(CategoryGroup);
